import { linkPlaidDraftToExpense } from "@healthshare/shared/commands/expenses"
import { useAsyncAction } from "./useAsyncAction"
import { useBackendApi } from "./useBackendApi"

export interface LinkDraftToExpenseParams {
  draftId: string
  targetId: string
}

/**
 * Manually link a Plaid-imported draft expense onto an existing expense. The
 * backend records the draft's bank charge as a payment on the target,
 * re-points the plaid_transaction, and soft-deletes the draft — all
 * authoritatively in one transaction.
 *
 * We deliberately do NOT optimistically mutate Redux here: both the target's
 * appended payment and the draft's removal arrive via the next sync-down
 * (onSyncDownComplete). The server append is idempotent, so a sync that races
 * the request can never double-record the payment. Callers read the returned
 * `result.loading` / `result.error` to drive the in-flight UI.
 */
export function useLinkDraftToExpense() {
  const api = useBackendApi()

  return useAsyncAction(async ({ draftId, targetId }: LinkDraftToExpenseParams) => {
    await linkPlaidDraftToExpense(api, draftId, targetId)
  }, [api])
}
